// extracted by mini-css-extract-plugin
export default {"mCard":"hz-z","image":"iz-z","imageNoBackground":"jz-z","imageHasCategory":"kz-z","fullWidth":"lz-z"};